import {
  Org as Icon
} from 'components/icons';

export const meta = {
  id: 'OrgsDetails',
  title: 'OrgsDetails',
  category: 'Scopes',
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The ORG crud component`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 840,
    height: 740
  }
};
